import { C8Node } from "csi/typings";
import xml from "csi/xml";

export function getInitials(user: C8Node): string {
	return ([user.FirstName, user.LastName].filter(Boolean).map((s) => s.substring(0, 1).toLocaleUpperCase())
		.join(""))
		|| user.$Name?.substring(0, 1).toLocaleUpperCase();
}

export function isExternal(user: C8Node): boolean {
	return xml.isValidURL(user.__Parent__);
}

